module.exports = __webpack_public_path__ + "static/media/dropdown-focus.b6e8eb20.svg";